export default __webpack_public_path__ + "static/media/TaxfreeRetirementPlans.69f1e229.svg";